<template>
  <OrderCard :title="t('order.cardTitles.note')" class="sm:grid-cols-3">
    <FormField v-slot="{ componentField }" name="comment">
      <FormItem class="col-span-full">
        <FormControl>
          <Textarea
            :placeholder="t('order.formLabels.notePlaceholder')"
            class="resize-none"
            v-bind="componentField"
          />
        </FormControl>
        <FormMessage />
      </FormItem>
    </FormField>
  </OrderCard>
</template>
<script setup lang="ts">
import { Textarea } from "../../textarea";
import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "../../form";
import { OrderCard } from "../../card";

import { useI18n } from "vue-i18n";
const { t } = useI18n();
</script>
